import React from 'react';
import { UnitFragment } from '../../../generated/graphql';

import { ImageListItem, ImageList, ImageListItemBar, Stack, useMediaQuery, useTheme, Typography } from '@mui/material';
import { UploadButton } from '../../../components/upload-button';
import { ClipboardPasteButton } from '../../../components/clipboard-paste-button';

interface UnitPhotoSectionProps {
  unit: UnitFragment;
  uploadInProgress?: boolean;
  onSelectPhoto: (idx: number) => void;
  handlePhotoUpload: (id: string, file: File) => void;
  disabled?: boolean;
  onError?: (message: string) => void;
}

export function UnitPhotoSection({
  unit,
  uploadInProgress = false,
  handlePhotoUpload,
  onSelectPhoto,
  disabled,
  onError,
}: UnitPhotoSectionProps) {
  const theme = useTheme();
  const isLargerThanXs = useMediaQuery(theme.breakpoints.up('sm'));
  const isLargerThanMd = useMediaQuery(theme.breakpoints.up('lg'));

  const photoHeight = isLargerThanXs ? 200 : 150;

  return (
    <Stack spacing={1} minHeight={'10rem'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <UploadButton
          label="Pridať fotku"
          inProgress={uploadInProgress}
          onUpload={(file) => handlePhotoUpload(unit.id, file)}
          variant="outlined"
          disabled={disabled}
          fullWidth={!isLargerThanXs}
        />
        <ClipboardPasteButton
          label="Prilepiť zo schránky"
          inProgress={uploadInProgress}
          onPaste={(file) => handlePhotoUpload(unit.id, file)}
          onPasteError={onError}
          variant="outlined"
          disabled={disabled}
          fullWidth={!isLargerThanXs}
        />
      </Stack>
      {unit.photos.length === 0 && (
        <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'left', marginTop: '2rem' }}>
          Neboli nájdené žiadne fotky
        </Typography>
      )}
      {unit.photos.length > 0 && (
        <ImageList sx={{ width: '100%' }} cols={isLargerThanXs ? (isLargerThanMd ? 10 : 5) : 3} rowHeight={photoHeight}>
          {unit.photos
            .filter((p) => !p.deletedAt)
            .map((p, idx) => (
              <ImageListItem
                key={p.id}
                sx={{
                  '& img': {
                    height: '100% !important',
                    objectFit: 'contain !important',
                  },
                }}
              >
                <img
                  src={p.urlXs ?? undefined}
                  alt={p.desc ?? undefined}
                  loading="lazy"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!disabled) {
                      onSelectPhoto(idx);
                    }
                  }}
                />
                <ImageListItemBar title={p.desc ?? undefined} position="below" />
              </ImageListItem>
            ))}
        </ImageList>
      )}
    </Stack>
  );
}
